import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage, useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { questionById } from "../../../behaviours/questionById";
import { useAnswers, useAnswerForId } from "../../../behaviours/useAnswers";
import { style as hostScreenWithSummaryAnswersStyle } from "./HostScreenWithSummaryAnswers.style";
const HostScreenWithSummaryAnswers = ({ domain, segment, question, style: customStyle, }) => {
    const style = useMemo(() => hostScreenWithSummaryAnswersStyle(), []);
    const { questionsFilteredByAnswers } = useAnswers();
    const { answer } = useAnswerForId({ id: question.id });
    const questions = answer?.reduce((acc, answer) => {
        const question = questionById({ questionId: answer, questions: questionsFilteredByAnswers });
        return [...acc, ...(question ? [question] : [])];
    }, []) || [];
    const { formatMessage } = useI18n({ domain });
    const titleText = useI18nMessage({
        domain,
        id: question.metadata.summaryTranslationKey,
        values: { segment: segment.toLowerCase() },
    });
    return answer ? (React.createElement(View, { style: customStyle, testID: "host-screen-with-summary-answers" },
        React.createElement(Text, { level: 3, style: style.title, variant: "action" }, titleText),
        questions.map((question) => (React.createElement(Text, { key: question.id, level: 3, style: style.answer, testID: question.id }, formatMessage({ id: question.translationKey }, { segment: segment.toLowerCase() })))))) : null;
};
export { HostScreenWithSummaryAnswers };
